import { useInsertionEffect, useRef } from 'react';
import { useSheets } from './SheetContext';
import { DEFAULT_BREAKPOINT_NAME } from './constants';
function createCacheKey(cssRuleTriple) {
  const [selector, __, mediaQuery] = cssRuleTriple;
  return `${!mediaQuery ? DEFAULT_BREAKPOINT_NAME : mediaQuery}::${selector}`;
}
export default function useLiveUpdateCss(cssRuleTriple) {
  const sheets = useSheets();
  const selectorCache = useRef(new Map());
  useInsertionEffect(() => {
    const cache = selectorCache.current;
    const newCache = new Map();
    cssRuleTriple.forEach(triple => {
      const [selector, ruleset, mediaQuery] = triple;
      const cacheKey = createCacheKey(triple);
      newCache.set(cacheKey, [selector, mediaQuery !== null && mediaQuery !== void 0 ? mediaQuery : '']);
      cache.delete(cacheKey);
      if (sheets) {
        sheets[mediaQuery || DEFAULT_BREAKPOINT_NAME].addRule(selector, ruleset, mediaQuery);
      }
    });
    // Clean up any rules that were removed from the previous render
    if (sheets) {
      for (const [selector, mediaQuery] of cache.values()) {
        sheets[mediaQuery || DEFAULT_BREAKPOINT_NAME].deleteRule(selector, mediaQuery);
      }
    }
    selectorCache.current = newCache;
  }, [cssRuleTriple]);
}